import { render } from "./SelectOrderTransition.vue?vue&type=template&id=c96d67a6"
import script from "./SelectOrderTransition.vue?vue&type=script&lang=js"
export * from "./SelectOrderTransition.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__